<template>
	<!-- 회원 탈퇴 전용 팝업 -->
	<div class="popup" style="width:600px;" v-click-outside="() => emit('closeAll')">
		<div class="popup-top">
			<strong>{{ lang.title('withdraw') }}</strong>
			<button class="btn-back" @click="onClose"></button>
			<button class="btn-close mob-hide" @click="onClose"></button>
		</div>
		<div class="popup-btm">
			<div class="form-view">
				<table>
					<colgroup>
						<col style="width:150px" />
						<col />
					</colgroup>
					<tbody>
					<tr>
						<th>{{ lang.label('withdrawReason') }} <span class="bullet">*</span></th>
						<td>
							<v-textarea
								v-model="reason"
								class="custom-textarea"
								rows="8"
								no-resize
								:placeholder="lang.placeholder('withdrawReason')"
							/>
						</td>
					</tr>
					</tbody>
				</table>
			</div>
		</div>
		<div class="popup-btn">
			<v-btn class="custom-btn btn-white" @click="onClose">{{ lang.button('cancel') }}</v-btn>
			<v-btn class="custom-btn btn-blue" :disabled="!reason.trim()" @click="onConfirm">
				{{ lang.button('withdraw') }}
			</v-btn>
		</div>
	</div>
</template>


<script setup lang="ts">
import { ref } from 'vue';
import {useMyInfo} from "~/composables/useMyInfo";
import { useLanguage } from "~/composables/useLanguage";

const { lang } = useLanguage();

// close 와 confirm(reason: string) 이벤트를 부모로 emit
const emit = defineEmits<{
	(e: 'close'): void;
	(e: 'closeAll'): void;
	(e: 'confirm'): void;
}>();

// 탈퇴 사유를 저장하는 ref
const reason = ref('');

// 팝업 닫기 이벤트 핸들러
function onClose() {
	emit('close');
}

const {
	id,//사용자 아이디
	handleUserWithdrawal
} = useMyInfo();

// 탈퇴 사유가 입력되었는지 확인하고 부모로 이벤트 emit
function onConfirm() {
	if (!reason.value.trim()) {
		// 사유가 비었을 때 처리
		return;
	}

	// 여기에 탈퇴 API 요청 로직을 추가합니다.
	handleUserWithdrawal(id.value);

	// 탈퇴 API 요청 처리
	console.log("탈퇴사유:", reason.value);
	emit('confirm');
}
</script>